module.exports = __webpack_public_path__ + "static/media/detective_intro2_spritesheet.28de8d83.png";